/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

// Vlastnosti nav�zan� pro v�echny z�znamy objektu

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnostTypSubjektu extends GContentBase<SeznamAdmVlastnostTypSubjektuObj> {
        private seznamObj: SeznamAdmVlastnostTypSubjektuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostTypSubjektuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnostTypSubjektuNew",
                contentCaption: "jres:33000486", //RC 33000486 : Roz�i�uj�c� vlastnosti povolen� pro z�znamy typu objektu
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{typ_obj_txt} - {ixs_txt} - {ico}"
                },
                gridSettings: {
                    columnOrder: "typ_obj_txt,typ_vps_txt,ixs_txt,ico_txt,poznamka,dat_zmena,zmenu_provedl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostTypSubjektuObj extends GAdmSeznamBase {
        private typ_obj: number;
        private ico: string;
        private ixs: string;
        typ_vps: number;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostTypSubjektu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnostTypSubjektu",
                newRecord: isNew,
                typ_obj: isNew == true ? ((this.typ_obj) ? this.typ_obj : null) : data.typ_obj,
                ixs: isNew == true ? ((this.ixs) ? this.ixs : null) : data.ixs,
                typ_vps: isNew == true ? ((this.typ_vps) ? this.typ_vps : null) : data.vps,
                ico: isNew == true ? ((this.ico) ? this.ico : null) : data.ico,
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {

            }
            //return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            if (this.ixs) {
                if (this.typ_vps != null && this.typ_vps != undefined) {
                    switch (this.typ_vps) {
                        case 0:
                            this.filterForm.addRow("jres:33000410").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                                name: "ixs",
                                model: "model.ixs=value.ixs_pro",
                                disabled: this.ixs ? true : false,
                                dropdown: true,
                                serverFilters: {
                                    aktivita: 100,
                                    priz_vir: 0
                                },
                            })
                            break;
                        case 10:
                            this.filterForm.addRow("jres:29931622").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                                name: "ixs",
                                model: "model.ixs=value.ixs_stv",
                                disabled: this.ixs ? true : false,
                                dropdown: true,
                                serverFilters: {
                                    aktivita: 100,
                                    priz_vir: 0
                                },
                            })
                            break;
                        case 20:
                            this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                                name: "ixs",
                                model: "model.ixs=value.ixs_vla",
                                disabled: this.ixs ? true : false,
                                dropdown: true,
                                serverFilters: {
                                    aktivita: 100
                                },
                            })
                            break;
                    }
                }
            }
            this.filterForm.addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                name: "typ_obj",
                model: "model.typ_obj=value.typ_obj",
                disabled: this.typ_obj ? true : false,
                dropdown: true
            })/*.addRow("jres:32131046").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                name: "ico",
                model: "model.ico=value.ico",
                disabled: this.ico ? true : false,
                dropdown: true
            })*/
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.typ_obj)
                hardFilter["typ_obj"] = this.typ_obj
            if (this.ico)
                hardFilter["ico"] = this.ico
            if (this.ixs)
                hardFilter["ixs"] = this.ixs
            if (this.typ_vps != null && this.typ_vps != undefined)
                hardFilter["typ_vps"] = this.typ_vps
            return hardFilter;
        }

        collectData(data: any) {
            if (this.typ_obj)
                data["typ_obj"] = this.typ_obj
            if (this.ico)
                data["ico"] = this.ico
            if (this.ixs)
                data["ixs"] = this.ixs
            if (this.typ_vps != null && this.typ_vps != undefined)
                data["typ_vps"] = this.typ_vps
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnostTypSubjektu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.typ_obj, data.ixs, data.ico),
                nazev: ""
            }
        }
    }
}